
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[lang]/mietpreis-rechner",
      function () {
        return require("private-next-pages/[lang]/mietpreis-rechner.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[lang]/mietpreis-rechner"])
      });
    }
  